var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "callout",
      attrs: { "has-border": false, "has-toggle": false }
    },
    [
      _c("validation-observer", { ref: "evalutatorFromRef" }, [
        _c("div", { staticClass: "row mt-2 row-container py-2" }, [
          _c("div", { staticClass: "col-md-3 col-12 border-right status" }, [
            _c("div", { staticClass: "row" }, [
              !_vm.evaluator.isSpecialized
                ? _c(
                    "div",
                    { staticClass: "col-12 col-md-3" },
                    [
                      _c("custom-percentage", {
                        staticClass: "custom-percent",
                        attrs: {
                          percentage: Number(
                            _vm.evaluator.evaluationResult
                          ).toString()
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-12 col-md-9 d-none d-md-block" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Nombre:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("capitalize")(_vm.evaluator.fullName)) +
                      " "
                  ),
                  _vm.evaluator.isSpecialized
                    ? _c("span", { staticClass: "bold" }, [
                        _vm._v(" / Especializado ")
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-9" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 d-block d-md-none" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Nombre:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("capitalize")(_vm.evaluator.fullName)) +
                      " "
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-2" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Usuario:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(" " + _vm._s(_vm.evaluator.userName) + " ")
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-2" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Rol:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(" " + _vm._s(_vm.evaluator.roleName) + " ")
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-3" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Estatus:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(
                    " " + _vm._s(_vm.evaluator.proposalEvaluationName) + " "
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-3" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Fecha:")]),
                _c("span", { staticClass: "info" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("date")(_vm.evaluator.submittedDate)) +
                      " "
                  )
                ])
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-md-2 d-flex justify-content-center align-items-start"
                },
                [
                  !_vm.canDelete
                    ? _c("dropdown", {
                        staticClass: "actions-dropdown",
                        attrs: {
                          "data-item": {
                            evaluator: _vm.evaluator,
                            index: _vm.index
                          },
                          items: _vm.actionItems,
                          title: "Acciones"
                        }
                      })
                    : _vm._e(),
                  _vm.canDelete
                    ? _c(
                        "action-button",
                        {
                          staticClass: "py-1",
                          attrs: {
                            i: "fa fa-times-circle",
                            variant: "outline-danger"
                          },
                          on: {
                            click: function($event) {
                              return _vm.onRemoveHandler(_vm.evaluator)
                            }
                          }
                        },
                        [_vm._v(" Remover ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }